module.exports = __webpack_public_path__ + "static/media/logo-imaker.6ef0a79c.png";